export default "__VITE_ASSET__DUZWB46Z__"